// extracted by mini-css-extract-plugin
export default {"div_signatario":"styles_div_signatario__DzADU","inputCheck":"styles_inputCheck__5daFw"};